<template>
  <div class="container">
    <div class="mt-5">
      <h1 class="lh-base fw-bold">中國醫藥大學新竹附設醫院 視訊會診清單</h1>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
        class="mt-3"
      ></v-text-field>
    </div>
    <div>
      <v-data-table
        :headers="headers"
        :items="data"
        :search="search"
        class="table table-striped mt-3"
      >
        <template v-slot:item="{ item }">
          <tr class="lh-base fw-bold">
            <td style="font-size:20px">{{ item.id_number }}</td>
            <td style="font-size:20px">{{ item.msg.split("醫師:")[1] }} 醫師</td>
            <td style="font-size:20px">
              <a v-bind:href="item.url">點我連結至視訊</a>
            </td>
          </tr></template
        ></v-data-table
      >
    </div>
  </div>
</template>
<script>
export default {
  mounted() {
    const api = `http://220.130.50.225:8089/Cmuhch/Video_Consultation_Dr_data`;
    console.log(api);
    console.log(this.data);
    fetch(api, {
      method: "POST",
      body: JSON.stringify(this.user),
    })
      .then((res) => res.json())
      .catch((error) => {
        console.error("Error:", error);
      })
      .then((response) => {
        console.log("Success:", response);
        this.data = response.data;
      });
  },
  data() {
    return {
      search: "",
      headers: [
        {
          text: "員代",
          align: "start",
          value: "id_number",
        },
        { text: "醫生姓名", value: "msg" },
        { text: "視訊連結", value: "url" },
      ],
      data: [],
    };
  },
};
</script>
<style>
.v-data-table {
  font-size: 50px !important;
}
</style>
